import {
  CORE_AIR_PRICE_WATCH_NAME,
  CORE_DISRUPTION_NAME,
  CORE_TRIPS_NAME,
  CORE_UI_NAME,
  CoreAirPriceWatchComponent,
  CoreDisruptionComponent,
  CoreTripsComponent,
  CoreUiComponents,
  CORE_FLIGHTS_CFAR_NAME,
  CORE_FLIGHTS_NAME,
  CoreFlightsComponent,
} from "@b2bportal/core-types";
import howItWorksDialogStyles from "./disruption/components/HowItWorksDialog/HowItWorksDialog.module.scss";
import {
  disruptionOfferSectionStyles,
  dialogStyles,
  disruptionExerciseSelectionStyles,
  disruptionExerciseButtonStyles,
  disruptionExerciseSummaryCardStyles,
  disruptionExerciseOptionsCardStyles,
  disruptionExerciseHeaderStyles,
  disruptionExercisePolicyDetailsStyles,
  disruptionExerciseFooterStyles,
  disruptionExerciseRefundSummaryCardStyles,
  disruptionExerciseInformationCardStyles,
  disruptionExerciseBulletPointStyles,
  disruptionExerciseRefundReviewPageStyles,
  disruptionExerciseRefundConfirmationPageStyles,
  radioItemStyles,
  disruptionExerciseNotEligiblePageStyles,
  disruptionExerciseLearnMoreContentStyles,
  disruptionExpandableContainerStyles,
  disruptionExerciseFlightInfoRowStyles,
  disruptionExercisePopupStyles,
  iframeDialogStyles,
  disruptionExercisePageStyles,
  disruptionExerciseLoadingStyles,
  disruptionExerciseCheckboxStyles,
  airPriceWatchListPageStyles,
  airPriceWatchListStyles,
  noTripResults,
  externalLinkContainerStyles,
  disruptionExerciseRebookFlightShopPageStyles,
  flightDetailsSegmentStyles,
  flightDetailsStyles,
  disruptionExerciseCheckoutComponentStyles,
  disruptionExerciseRebookSelectFlightPageStyles,
  disruptionExerciseRebookCheckoutPage,
  disruptionExerciseSegmentSelectCard,
  toggleGroupStyles,
} from "./styles";
import { CORE_FINTECH_UI_STYLE_OVERRIDES } from "./styles/core-fintech-ui";
import { CORE_FLIGHTS_CFAR_EXERCISE_STYLE_OVERRIDES } from "./styles/core-flights-cfar-exercise";
import { CORE_FLIGHTS_CFAR_OFFERS_STYLE_OVERRIDES } from "./styles/core-flights-cfar-offers";

export const styleOverrides = {
  ...CORE_FINTECH_UI_STYLE_OVERRIDES,
  [CORE_FLIGHTS_CFAR_NAME]: {
    ...CORE_FLIGHTS_CFAR_OFFERS_STYLE_OVERRIDES[CORE_FLIGHTS_CFAR_NAME],
    ...CORE_FLIGHTS_CFAR_EXERCISE_STYLE_OVERRIDES[CORE_FLIGHTS_CFAR_NAME],
  },
  [CORE_UI_NAME]: {
    [CoreUiComponents.Dialog]: dialogStyles,
    [CoreUiComponents.IframeDialog]: iframeDialogStyles,
    [CoreUiComponents.RadioItem]: radioItemStyles,
    [CoreUiComponents.ToggleGroup]: toggleGroupStyles,
  },
  [CORE_DISRUPTION_NAME]: {
    [CoreDisruptionComponent.DisruptionOfferSection]:
      disruptionOfferSectionStyles,
    [CoreDisruptionComponent.HowItWorksDialog]: howItWorksDialogStyles,
    [CoreDisruptionComponent.DisruptionExerciseSelection]:
      disruptionExerciseSelectionStyles,
    [CoreDisruptionComponent.DisruptionExerciseButton]:
      disruptionExerciseButtonStyles,
    [CoreDisruptionComponent.DisruptionExerciseSummaryCard]:
      disruptionExerciseSummaryCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseOptionsCard]:
      disruptionExerciseOptionsCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseHeader]:
      disruptionExerciseHeaderStyles,
    [CoreDisruptionComponent.DisruptionExercisePolicyDetails]:
      disruptionExercisePolicyDetailsStyles,
    [CoreDisruptionComponent.DisruptionExerciseFooter]:
      disruptionExerciseFooterStyles,
    [CoreDisruptionComponent.DisruptionExerciseRefundSummaryCard]:
      disruptionExerciseRefundSummaryCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseInformationCard]:
      disruptionExerciseInformationCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseBulletPoint]:
      disruptionExerciseBulletPointStyles,
    [CoreDisruptionComponent.DisruptionExerciseRefundReviewPage]:
      disruptionExerciseRefundReviewPageStyles,
    [CoreDisruptionComponent.DisruptionExerciseRefundConfirmationPage]:
      disruptionExerciseRefundConfirmationPageStyles,
    [CoreDisruptionComponent.DisruptionExerciseNotEligiblePage]:
      disruptionExerciseNotEligiblePageStyles,
    [CoreDisruptionComponent.DisruptionExerciseLearnMoreContent]:
      disruptionExerciseLearnMoreContentStyles,
    [CoreDisruptionComponent.DisruptionExpandableContainer]:
      disruptionExpandableContainerStyles,
    [CoreDisruptionComponent.DisruptionExercisePopup]:
      disruptionExercisePopupStyles,
    [CoreDisruptionComponent.DisruptionExercisePage]:
      disruptionExercisePageStyles,
    [CoreDisruptionComponent.DisruptionExerciseLoading]:
      disruptionExerciseLoadingStyles,
    [CoreDisruptionComponent.ExternalLinkContainer]:
      externalLinkContainerStyles,
    [CoreDisruptionComponent.DisruptionExerciseFlightInfoRow]:
      disruptionExerciseFlightInfoRowStyles,
    [CoreDisruptionComponent.DisruptionExerciseRebookFlightShopPage]:
      disruptionExerciseRebookFlightShopPageStyles,
    [CoreDisruptionComponent.DisruptionExerciseCheckoutComponent]:
      disruptionExerciseCheckoutComponentStyles,
    [CoreDisruptionComponent.DisruptionExerciseRebookSelectFlightPage]:
      disruptionExerciseRebookSelectFlightPageStyles,
    [CoreDisruptionComponent.DisruptionExerciseRebookCheckoutPage]:
      disruptionExerciseRebookCheckoutPage,
    [CoreDisruptionComponent.DisruptionExerciseSegmentSelectCard]:
      disruptionExerciseSegmentSelectCard,
    [CoreDisruptionComponent.DisruptionExerciseCheckbox]:
      disruptionExerciseCheckboxStyles,
  },
  [CORE_AIR_PRICE_WATCH_NAME]: {
    [CoreAirPriceWatchComponent.WatchListPage]: airPriceWatchListPageStyles,
    [CoreAirPriceWatchComponent.WatchList]: airPriceWatchListStyles,
  },
  [CORE_TRIPS_NAME]: {
    [CoreTripsComponent.NoTripResults]: noTripResults,
  },
  [CORE_FLIGHTS_NAME]: {
    [CoreFlightsComponent.FlightDetailsSegment]: flightDetailsSegmentStyles,
    [CoreFlightsComponent.FlightDetails]: flightDetailsStyles,
  },
};
